module.exports = __webpack_public_path__ + "img/uploaddocuments.38da6d3f.png";